module.exports = __webpack_public_path__ + "static/media/Kids - Instrumental Version.144e411b.jpg";